<script>
    import ButtonInput from "../atoms/ButtonInput.svelte";
    import ButtonInputDisabled from "../atoms/ButtonInputDisabled.svelte";

    export let condition;
    export let onClick;
    export let value;
</script>

{#if condition}
    <ButtonInput value={value} bind:onClick={onClick}/>
{:else}
    <ButtonInputDisabled value={value}/>
{/if}